module.exports = __webpack_public_path__ + "static/media/wizualizacja-47.79a15183.png";